import { render, staticRenderFns } from "./SpecialPrecautionsRep.vue?vue&type=template&id=386d5856&"
import script from "./SpecialPrecautionsRep.vue?vue&type=script&lang=js&"
export * from "./SpecialPrecautionsRep.vue?vue&type=script&lang=js&"
import style0 from "./SpecialPrecautionsRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports